/**
 * React component that serves as a layout for "mini card"-style list item.
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Yucho Ho
 */
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Card } from 'reactstrap'
import useMediaQuery from 'client/shared/js/hooks/useMediaQuery'
import styles from './MiniCardListItem.module.scss'

const MiniCardListItem = ({
  className,
  leftChildren,
  children,
  rightChildren,
  header,
  image,
  imageClassName,
  onClick
}) => {
  const coverImage = useMemo(() => {
    return (image) ? (
      <div className={cx(styles['item-img'], imageClassName)}>
        <div className={cx(styles['img-container'])}>
          <div className={cx(styles['img-header'])}>
            {header}
          </div>
          {image}
        </div>
      </div>
    ) : null
  }, [header, image, imageClassName])

  const { isTablet } = useMediaQuery()

  return (
    <Card
      className={cx(styles['item'], className, { [styles['not-mobile']]: !isTablet })}
      onClick={onClick}>
      {(
        leftChildren ? (
          <div className={cx(styles['item-left'])}>
            {leftChildren}
          </div>
        ) : null
      )}
      {coverImage}
      <div className={cx(styles['item-body'])}>
        {children}
      </div>
      {(
        rightChildren ? (
          <div className={cx(styles['item-right'])}>
            {rightChildren}
          </div>
        ) : null
      )}
    </Card>
  )
}

MiniCardListItem.propTypes = {
  className: PropTypes.string,
  leftChildren: PropTypes.node,
  rightChildren: PropTypes.node,
  header: PropTypes.node,
  image: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  imageClassName: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node
}

export default MiniCardListItem
